import React from 'react';

import { ToolBarNav } from './toolbar.style';
import { ToolbarSidebarButton } from './toolbar-sidebar-button';

const Toolbar: React.FC = () => {
  return (
    <ToolBarNav>
      <ToolbarSidebarButton />
    </ToolBarNav>
  );
};

export { Toolbar };
